export const cityList = [
    "Agra",
    "Ahmedabad",
    "Amritsar",
    "Aurangabad",
    "Bangalore",
    "Bhubaneswar",
    "Bhopal",
    "Chandigarh",
    "Chennai (Madras)",
    "Coimbatore",
    "Darjeeling",
    "Delhi",
    "Dehradun",
    "Dibrugarh",
    "Goa",
    "Guwahati",
    "Gangtok",
    "Hyderabad",
    "Jaipur",
    "Jaisalmer",
    "Jodhpur",
    "Kochi (Cochin)",
    "Kolkata (Calcutta)",
    "Kanyakumari",
    "Kanpur",
    "Khajuraho",
    "Lucknow",
    "Mahabaleshwar",
    "Mumbai (Bombay)",
    "Mysore",
    "Ooty",
    "Palitana",
    "Patna",
    "Pondicherry",
    "Pune",
    "Puri",
    "Rameshwaram",
    "Ranchi",
    "Rishikesh",
    "Shimla",
    "Srinagar",
    "Surat",
    "Thiruvananthapuram (Trivandrum)",
    "Udaipur",
    "Varanasi",
    "Vadodara",
    "Vasco da Gama",
    "Visakhapatnam",
    "Warangal",
    "Yercaud"
]